"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Checkbox.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Checkbox = function Checkbox(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 32 32"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Checkbox"), _react2.default.createElement("g", {
    className: "checkbox",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "outer-box",
    d: "M3.2 0h25.6A3.2 3.2 0 0 1 32 3.2v25.6a3.2 3.2 0 0 1-3.2 3.2H3.2A3.2 3.2 0 0 1 0 28.8V3.2A3.2 3.2 0 0 1 3.2 0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "inner-box",
    d: "M4 1h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "check",
    d: "M23.28 9.1l-.91-.74a1 1 0 0 0-1.37.13l-7.72 11.07-2.21-2.72a1 1 0 0 0-1.4-.17l-.9.73a1 1 0 0 0-.17 1.4l3.85 4.73a1.57 1.57 0 0 0 1.66.19c.553-.431.993-.99 1.28-1.63l8-11.63a1 1 0 0 0-.11-1.36z",
    fill: "none",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: undefined
  })));
};
exports.default = Checkbox;